import React from "react";
import Users from "../../components/Users";
import "./Users.css";

export default function UsersAll() {
  return (
    <div className="users-all-main">
      <Users />
    </div>
  );
}